export default __webpack_public_path__ + "static/media/london.5b07c491.jpg";